module.exports = __webpack_public_path__ + "img/solarium_1_tn.b46bff37.jpg";